import React, { FC, useMemo, memo } from 'react'

import { styled } from '@mui/material'

import SubCondition from '../SubCondition'
import AddSubCondition from '../SubCondition/AddSubCondition'

import { useAppSelector } from '../../hooks/reduxHooks'

const RootContainer = styled('div')(() => ({
    padding: '24px',
}))

export interface GroupConditionBodyProps {
    groupIndex: number
}

const Body: FC<GroupConditionBodyProps> = (props) => {
    const subConditions = useAppSelector(({ groupConditions }) => groupConditions.groupConditions[props.groupIndex].conditions)

    const showDelete = useMemo(() => subConditions.length > 1, [subConditions.length === 1])

    return (
        <RootContainer>
            {subConditions.map((subCondition, index) => 
                <SubCondition 
                    key={index} 
                    index={index}
                    groupIndex={props.groupIndex} 
                    showDelete={showDelete}
                />)}
            <AddSubCondition index={props.groupIndex} />
        </RootContainer>
    )
}

export default memo(Body, (prevProps, nextProps) => prevProps.groupIndex === nextProps.groupIndex)